import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Cookie } from 'ng2-cookies';
var ConsentComponent = /** @class */ (function () {
    function ConsentComponent(router, spinnerService) {
        this.router = router;
        this.spinnerService = spinnerService;
        this.consentAccepted = false;
        this.typeSelected = 'ball-fussion';
    }
    ConsentComponent.prototype.ngOnInit = function () {
        this.spinnerService.hide();
        if (Cookie.get('consensus') === 'true') {
            // dont show consent form if already accepted
            console.log("Consent already accepted, redirecting to home page.");
            this.router.navigate(['/']);
        }
    };
    ConsentComponent.prototype.proceedToIdentification = function () {
        var _this = this;
        if (this.consentAccepted) {
            Cookie.set("consensus", "true");
        }
        else {
            Cookie.set("consensus", "false");
        }
        this.spinnerService.show();
        setTimeout(function () {
            _this.spinnerService.hide();
            _this.router.navigate(['/']);
        }, 1000);
    };
    return ConsentComponent;
}());
export { ConsentComponent };
